import { type QueryClient, useQuery } from "@tanstack/react-query"

import { dailyContentApi } from "@/lib/daily-content-api"
import { dailyContentKeys } from "@/lib/query-keys"

export const useProfiles = () => {
  return useQuery({
    queryKey: dailyContentKeys.profiles(),
    queryFn: dailyContentApi.listProfiles,
  })
}

export const refreshProfiles = async (queryClient: QueryClient) => {
  await queryClient.invalidateQueries({
    queryKey: dailyContentKeys.profiles(),
  })
}
